import React from 'react';
import { IoFilterSharp } from 'react-icons/io5';
import type { FileFilters } from '../../../../types/file.types';

interface FilterButtonProps {
  openFilter: boolean;
  setOpenFilter: (value: boolean) => void;
  filters: FileFilters[];
  filterButtonRef: React.RefObject<HTMLDivElement>;
}

export const FilterButton = ({
  openFilter,
  setOpenFilter,
  filters,
  filterButtonRef,
}: FilterButtonProps) => {
  return (
    <div className="relative" ref={filterButtonRef}>
      <button
        onClick={() => setOpenFilter(!openFilter)}
        className="text-md inline-flex h-9 items-center rounded-md bg-neutralBG px-3 text-sm shadow-md transition-all duration-300 hover:bg-[#eaeaed] dark:bg-[#333135] dark:hover:bg-[#545454]"
      >
        <IoFilterSharp
          className={`mr-2 text-xl transition-all duration-300 ${
            filters.length > 0
              ? 'text-primary'
              : 'text-neutralText dark:text-neutralText-dark'
          }`}
        />
        <span className="flex items-center">
          Filtrer
          {filters.length > 0 && (
            <span className="ml-2 inline-flex h-5 w-5 items-center justify-center rounded-md bg-primary text-xs font-medium text-white transition-all duration-300 dark:bg-primary">
              {filters.length}
            </span>
          )}
        </span>
      </button>
    </div>
  );
};
